/* eslint-disable react/no-did-update-set-state */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React from 'react';

import { connect } from 'react-redux';
import PropTypes, { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import * as chooseDeliveryActions from '../../choose-delivery/store/actions';
import { getPaymentType, getCharities, getCharityId } from '../../choose-delivery/store/selectors';
import * as basketActions from '../../basket/store/actions';
import { getSearchData, getTotal, getBasket } from '../../basket/store/selectors';
import { getDiscountCode, getDiscountCodeStatus, getActiveDiscountCode } from '../store/selectors';
import * as profileActions from
'../../account/components/AccountTab/components/MyProfile/store/actions';
import * as getPaidActions from '../store/actions';
import {
  getProfile,
  getSuccess,
  getPaypal,
  getConfirmPaypalEmail,
  getValidatePaypalResult,
} from '../../account/components/AccountTab/components/MyProfile/store/selectors';
import styles from './styles';
import { Voucher, Charity, DiscountCode } from '../components';
import secure from '../../../images/secure-icon.png';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';
import {
  BasketTotal,
  Button,
  BankTransfer,
  PayPal,
} from '../../../components';

import { CRAFTY_CLICKS_API_KEY } from '../../../config/apiKeys';
import {
  BANK_TRANSFER, PAYPAL, VOUCHER, CHARITY
} from '../../../config/constants';
import { getPrice } from '../../../services/priceHelper';

class GetPaidPage extends React.Component {
  state = {
    errorMessage: null,
  };

  findEmptyFields = (paymentMethod) => {
    const errors = {
      AccountName: 'Enter Account Name or choose another payment method',
      SortCode: 'Enter Sort Code or choose another payment method',
      AccountNumber: 'Enter  Account Number or choose another payment method',
      PaypalEmail: 'Enter Email or choose another payment method',
    };
    this.setState({ errorMessage: null });
    return (
      Object.keys(paymentMethod).every(
        (key) => {
          if (!paymentMethod[key]) {
            this.setState({ errorMessage: errors[key] });
            return false;
          }
          return true;
        }
      )
    );
  }

  setLocalStorage = () => {
    const {
      profile,
      paymentType,
      total,
    } = this.props;
    const aboutPage = {
      page: 'getpaid',
      isBank: paymentType === BANK_TRANSFER,
      isPaypal: paymentType === PAYPAL,
    };
    localStorage.setItem('aboutPage', JSON.stringify(aboutPage));
    localStorage.setItem('profile', JSON.stringify(profile));
    localStorage.setItem('paymentType', JSON.stringify(paymentType));
    localStorage.setItem('total', JSON.stringify(total));
  }

  onConfirmRequest = () => {
    const { profile, ConfirmPaypalEmail, paymentType } = this.props;
    this.setLocalStorage();
    if (paymentType === PAYPAL) {
      this.props.validatePayPalEmail({
        PaypalEmail: profile.paypal.PaypalEmail,
        ConfirmPaypalEmail,
      });
    } else {
      const id = localStorage.getItem('loggedID');
      const token = localStorage.getItem('token');
      this.props.requestProfileEdit(
        profile,
        id,
        token,
        {
          page: 'getpaid',
          isBank: paymentType === BANK_TRANSFER,
          isPaypal: paymentType === PAYPAL,
        },
        '/choose-delivery',
      );
    }
  }

  onConfirm = () => {
    const id = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    const { paymentType, verifyBankAccount, charityId } = this.props;
    const { profile } = this.props;

    if (paymentType === BANK_TRANSFER) {
      this.props.resetErrorsAndSuccess();
      if (this.findEmptyFields(profile.bank)) {
        this.setLocalStorage();
        verifyBankAccount(
          {
            key: CRAFTY_CLICKS_API_KEY,
            sortCode: this.props.profile.bank.SortCode,
            accountNumber: this.props.profile.bank.AccountNumber,
          },
          {
            profile: this.props.profile,
            id,
            token,
            pageInfo: {
              page: 'getpaid',
              isBank: true,
              isPaypal: false,
            },
            to: '/choose-delivery',
          },
        );
      }
    } else if (paymentType === PAYPAL) {
      if (this.findEmptyFields(profile.paypal)) {
        this.onConfirmRequest();
      }
    } else if (paymentType === CHARITY) {
      localStorage.removeItem('CharityID');
      if (charityId) {
        localStorage.setItem('CharityID', JSON.stringify(charityId));
        this.onConfirmRequest();
      } else {
        this.setState({ errorMessage: 'Choose charity name' });
      }
    } else {
      this.onConfirmRequest();
    }
  }

  componentDidMount() {
    const id = localStorage.getItem('loggedID');
    const CartID = localStorage.getItem('CartID');
    this.props.requestBasket(CartID);
    localStorage.setItem('initialPaypal', JSON.stringify(this.props.profile.paypal.PaypalEmail));
    this.props.getCharities();

    if (id) {
      const items = this.props?.basket.map((item) => {
        return {
          item_id: item.EAN,
          item_name: item.Title,
          currency: 'GBP',
          price: item.SellbackPrice,
          quantity: 1
        };
      });
      const totalCost = items?.reduce((acc, item) => acc + item.price, 0);

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_payment_info',
        ecommerce: {
          currency: 'GBP',
          value: totalCost,
          coupon: this.props.activeDiscountCode?.Code ?? '',
          items
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.resetErrorsAndSuccess();
    this.props.selectCharityId(null);
  }

  render() {
    const {
      total,
      classes,
      paymentType,
      validatePaypalResult,
      success,
      charities,
      selectCharityId,
      discountCode,
      setDiscountCode,
      validateDiscountCode,
      discountCodeStatus,
      activeDiscountCode,
    } = this.props;

    const discountProps = {
      discountCode,
      setDiscountCode,
      validateDiscountCode,
      discountCodeStatus,
    };

    const { errorMessage } = this.state;
    const questionText = 'How would you like us to pay you?';
    const noteText = ` Your method of payment can't be altered
     once a shipment has been received by SellitBack.com`;
    const secureText = 'We keep your information secure';
    const voucherTitle = 'GIFT VOUCHER - 10% EXTRA';
    const charityTitle = 'DONATE TO CHARITY';

    let needItem = 10;
    let needMoney = 10;
    needMoney = 10 - total.price;
    needMoney = parseFloat(needMoney.toFixed(2));
    needItem = 10 - total.items;
    const isAll = needMoney <= 0 || needItem <= 0;
    const isBookshop = parseInt(localStorage.getItem('isBookshop'), 10);

    return (
      <PaperLayout hasSubPaper={false} label={'GET PAID'}>
        <div className={classes.basketTotalContainer}>
          <BasketTotal
            price={getPrice(activeDiscountCode, total)}
            items={total.items}
            isAll={isAll}
            activeDiscountCode={activeDiscountCode}
          />
        </div>

        {!isBookshop && <DiscountCode {...discountProps} />}
        <form className={classes.selectPaymentForm}>
          <p className={classes.questionText}>{questionText}</p>
          <BankTransfer
            type={BANK_TRANSFER}
            text={'BANK ACCOUNT'}
            selectedPaymentType={paymentType}
            setPaymentType={() => this.props.setPaymentType(BANK_TRANSFER)}
          />
          <PayPal
            type={PAYPAL}
            selectedPaymentType={paymentType}
            setPaymentType={() => this.props.setPaymentType(PAYPAL)}
          />
          <p className={classes.noteTextContainer}>
            <span className={classes.noteText}>Note:</span>
            {noteText}
          </p>
          <div className={classes.secureTextContainer}>
            <img className={classes.secureImage} src={secure} alt={'secure'} />
            <span
              className={classNames(classes.noteText, classes.marginLeft)}
            >
              {secureText}
            </span>
          </div>
          <Voucher
            text={voucherTitle}
            price={getPrice(activeDiscountCode, total, true)}
            selectedPaymentType={paymentType}
            setPaymentType={() => this.props.setPaymentType(VOUCHER)}
          />
          <Charity
            text={charityTitle}
            selectedPaymentType={paymentType}
            setPaymentType={() => this.props.setPaymentType(CHARITY)}
            charities={charities}
            selectCharityId={(charityId) => {
              if (this.state.errorMessage) this.setState({ errorMessage: null });
              selectCharityId(charityId);
            }}
          />
        </form>
        <h6 className={classNames(classes.updateText, classes.rejectedColor)}>
          {errorMessage}
        </h6>
        <div>
          {(validatePaypalResult.Success !== null && success.status === null)
            && (
              <h6 className={classNames(classes.updateText, classes.rejectedColor)}>
                {validatePaypalResult.Message}
              </h6>
            )}
          {success.status !== null
            && (
              <h6 className={classNames(classes.updateText,
                !success.status ? classes.rejectedColor : null)}
              >
                {success.getpaid}
              </h6>
            )}
        </div>
        <Button
          text={'SELL NOW'}
          onPress={() => this.onConfirm()}
        />
      </PaperLayout>
    );
  }
}

GetPaidPage.propTypes = {
  classes: PropTypes.object,
  total: PropTypes.object,
  requestBasket: PropTypes.func,
  setPaymentType: PropTypes.func,
  profile: PropTypes.object,
  success: PropTypes.object,
  resetErrorsAndSuccess: PropTypes.func,
  paymentType: PropTypes.number,
  paypal: PropTypes.object,
  ConfirmPaypalEmail: PropTypes.string,
  validatePaypalResult: PropTypes.object,
  validatePayPalEmail: PropTypes.func,
  verifyBankAccount: PropTypes.func,
  charities: PropTypes.array,
  selectCharityId: PropTypes.func,
  getCharities: PropTypes.func,
  charityId: PropTypes.number,
  requestProfileEdit: PropTypes.func,
  discountCode: PropTypes.string,
  setDiscountCode: PropTypes.func,
  validateDiscountCode: PropTypes.func,
  discountCodeStatus: PropTypes.object,
  activeDiscountCode: PropTypes.object,
  basket: object,
};
GetPaidPage.defaultProps = {
  classes: {},
  total: {
    price: 0,
    items: 0,
  },
  requestBasket: () => { },
  setPaymentType: () => { },
  profile: {},
  success: {},
  resetErrorsAndSuccess: () => { },
  paymentType: BANK_TRANSFER,
  paypal: {},
  ConfirmPaypalEmail: null,
  validatePaypalResult: {},
  validatePayPalEmail: () => { },
  verifyBankAccount: () => { },
  charities: [],
  selectCharityId: () => { },
  getCharities: () => { },
  charityId: null,
  requestProfileEdit: () => { },
  discountCode: '',
  setDiscountCode: () => { },
  validateDiscountCode: () => { },
  discountCodeStatus: {},
  activeDiscountCode: {},
  basket: [],
};

const mapStateToProps = (state) => {
  return {
    search: getSearchData(state),
    total: getTotal(state),
    profile: getProfile(state),
    success: getSuccess(state),
    paymentType: getPaymentType(state),
    paypal: getPaypal(state),
    ConfirmPaypalEmail: getConfirmPaypalEmail(state),
    validatePaypalResult: getValidatePaypalResult(state),
    charities: getCharities(state),
    charityId: getCharityId(state),
    discountCode: getDiscountCode(state),
    discountCodeStatus: getDiscountCodeStatus(state),
    activeDiscountCode: getActiveDiscountCode(state),
    basket: getBasket(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestBasket: data => dispatch(basketActions.requestBasket(data)),
    setPaymentType: data => dispatch(chooseDeliveryActions.setPaymentType(data)),
    validatePayPalEmail: validatePayPal => dispatch(profileActions
      .validatePayPalEmail(validatePayPal)),
    resetErrorsAndSuccess: () => dispatch(profileActions.resetErrorsAndSuccess()),
    setIsCollectionArranged: payload => dispatch(chooseDeliveryActions
      .setIsCollectionArranged(payload)),
    verifyBankAccount: (data, dataForNextRequest) => dispatch(profileActions
      .verifyBankAccount(data, dataForNextRequest)),
    selectCharityId: charityId => dispatch(chooseDeliveryActions.selectCharityId(charityId)),
    getCharities: () => dispatch(chooseDeliveryActions.getCharities()),
    requestProfileEdit: (profile, id, token, aboutPage, to) => dispatch(
      profileActions.requestProfileEdit(profile, id, token, aboutPage, to)
    ),
    setDiscountCode: (value, field) => dispatch(getPaidActions.setDiscountCode(value, field)),
    validateDiscountCode: () => dispatch(getPaidActions.validateDiscountCode()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(GetPaidPage));
